/* Naruto Birthday 10/10-10/17: auto-add 1 free Cute Beast Party S2 box when cart reaches $40 (tag price). */
(function () {
  var END = Date.parse('2026-10-18T07:00:00Z');
  if (Date.now() > END) return;
  var HANDLE = 'naruto-birthday-free-gift-box', GIFT = null, MIN = 4000, KEY = 'nbGiftAdded';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var _fetch = window.fetch.bind(window);
  var busy = false, timer = null;

  function isGift(i) { return i.variant_id === GIFT || i.handle === HANDLE; }
  function json(r) { return r.json(); }

  function refreshUI(state) {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && state && state.sections && drawer.renderContents) {
      try { drawer.renderContents(state); return; } catch (e) {}
    }
    _fetch(root + '?sections=cart-icon-bubble').then(json).then(function (s) {
      var el = document.getElementById('cart-icon-bubble');
      if (el && s['cart-icon-bubble']) {
        var d = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (d) el.innerHTML = d.innerHTML;
      }
    }).catch(function () {});
  }

  function loadGift() {
    if (GIFT) return Promise.resolve(GIFT);
    return _fetch(root + 'products/' + HANDLE + '.js').then(json).then(function (p) { GIFT = p.variants[0].id; return GIFT; });
  }

  function check() {
    if (busy || Date.now() > END) return;
    busy = true;
    loadGift().then(function () { return _fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(json).then(function (cart) {
      var base = 0, gift = null;
      var extra = [];
      cart.items.forEach(function (i) { if (isGift(i)) { if (gift) extra.push(i); else gift = i; } else base += i.original_line_price; });
      if (extra.length) {
        var upd = {}; extra.forEach(function (i) { upd[i.key] = 0; });
        return _fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: upd, sections: 'cart-drawer,cart-icon-bubble' }) }).then(json).then(refreshUI);
      }
      var sections = 'cart-drawer,cart-icon-bubble';
      if (base >= MIN) {
        if (!gift) {
          if (sessionStorage.getItem(KEY)) return; // customer removed it themselves
          return _fetch(root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: GIFT, quantity: 1 }], sections: sections })
          }).then(json).then(function (s) { sessionStorage.setItem(KEY, '1'); refreshUI(s); });
        }
        if (gift.quantity > 1) {
          return _fetch(root + 'cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: gift.key, quantity: 1, sections: sections })
          }).then(json).then(refreshUI);
        }
      } else {
        sessionStorage.removeItem(KEY);
        if (gift) {
          return _fetch(root + 'cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: gift.key, quantity: 0, sections: sections })
          }).then(json).then(refreshUI);
        }
      }
    }); }).catch(function () {}).then(function () { busy = false; });
  }

  function later() { clearTimeout(timer); timer = setTimeout(check, 800); }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(later, later);
    return p;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later); else later();
})();
